import * as React from 'react';
import {Link} from "react-router";
import Input from '../Input-new/Input';
import svgPlus from "../../svgs/TrainingPlus.svg";
import Icon from "../Icon";
import Trash from "../../svgs/Trash.svg";

export default function SubChapterCard({id, title, img, index, link, newWindow, handleParentChange, handleParentBlur, isEdit, error, validateSelectedFile, handlePasteImage, deleteCard, removePhoto, newChapter, isNewChapter, addNewChapter, canDelete = false}) {
    const fileInputRef = React.createRef();
    const hasIndex = Number.isFinite(index);
    const metaLabel = hasIndex ? String(index).padStart(2, '0') : 'Video';
    const footerLabel = newWindow ? 'Watch now' : 'Open lesson';
    const summary = newWindow
        ? 'Watch a guided walkthrough that reinforces the main ideas from this course.'
        : 'Open this lesson for a focused, step-by-step walkthrough of the topic.';
    
    const chooseFile = (e) => {
        validateSelectedFile(e, id)
    }
    
    return (
        !isEdit ?
        <Link to={link} target={newWindow ? '_blank' : ''} className={`SubChapterCard lesson-card ${!img ? 'lesson-card--textOnly' : ''}`}>
            {img ? (
                <div className="lesson-card__thumbnail">
                    <img src={img} alt={title} />
                </div>
            ) : null}
            
            <div className={img ? "lesson-card__body" : "card-content"}>
                <h3 className="lesson-card__title">
                    {title && title.includes('<br/>') 
                        ? title.split('<br/>').map((row, i) => (
                            <React.Fragment key={i}>{row}{i < title.split('<br/>').length - 1 && <br />}</React.Fragment>
                        ))
                        : title
                    }
                </h3>
                <div className={`lesson-card__meta ${!hasIndex ? 'lesson-card__meta--video' : ''}`} style={{marginLeft: 'auto'}}>
                    {metaLabel}
                </div>
                {/* <p className="lesson-card__summary">{summary}</p> */}
            </div>
            
            {/* <div className="lesson-card__footer">
                <span className="lesson-card__footer-text">{footerLabel}</span>
                <span className="lesson-card__footer-arrow">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                </span>
            </div> */}
        </Link>
        :
        !isNewChapter ?
            <div className="SubChapterCard edit-card">               
                <div className="card_body" tabIndex={0} onPaste={handlePasteImage ? (e) => handlePasteImage(e, id) : undefined}>
                    {canDelete &&
                        <div className="deleteIcon">
                            <Icon svg={Trash} onClick={()=>deleteCard(id)}/>
                        </div>
                    }
                    <div className='overlay'/>
                    <input className='hidden' type="file" 
                    ref={fileInputRef} 
                    accept={"image/png, image/jpeg, image/jpg, .svg"} 
                    onChange={chooseFile}
                    />
                    <div className="button-container">
                        <input className={`button-new ${!img ? 'positive':'negative'}`}
                                type="button"
                                value={`${!img ?'Choose' : 'Remove'} Photo`}
                                onClick={!img ? () => fileInputRef.current.click() : () => removePhoto(id)}
                                />
                        {!img &&
                            <span className="paste-hint" style={{display:'block', marginTop:'6px', fontSize:'11px', color:'#888'}}>or click the card &amp; paste (Ctrl/Cmd+V)</span>
                        }
                    </div>
                    <div className="error-container">
                        {
                            error &&
                            <span className='error'>{error}</span>
                        }
                    </div>
                    {
                        img &&
                        <img src={img} className="card_image" alt=''/>
                    }
                </div>
                <div className="card_title">
                    <div className="index">
                        #
                        <Input theme='white' 
                            name={id+'_index'}
                            value={index}
                            handleParentChange={handleParentChange}
                            handleParentBlur={handleParentBlur}/> 
                        -
                    </div>
                    <Input theme='white' 
                            className='title-input'
                            name={id+'_title'}
                            value={title}
                            handleParentChange={handleParentChange}
                            handleParentBlur={handleParentBlur}/> 
                </div>                    
            </div>
        :
        <React.Fragment> 
            {newChapter.visible &&
            <div className="SubChapterCard edit-card">
                <div className="card_body" tabIndex={0} onPaste={handlePasteImage ? (e) => handlePasteImage(e) : undefined}>
                    <div className='overlay'/>
                    <input className='hidden' type="file" ref={fileInputRef} accept={"image/png, image/jpeg, image/jpg, .svg"} onChange={validateSelectedFile}/>
                    <div className='button-container'>
                        <input className={`button-new ${!newChapter.img ? 'positive':'negative'}`}
                                type="button"
                                value={`${!newChapter.img ?'Choose' : 'Remove'} Photo`}
                                onClick={!newChapter.img ? () => fileInputRef.current.click() : () => removePhoto()} />
                        {!newChapter.img &&
                            <span className="paste-hint" style={{display:'block', marginTop:'6px', fontSize:'11px', color:'#888'}}>or click the card &amp; paste (Ctrl/Cmd+V)</span>
                        }
                        {
                            error &&
                            <span className='error'>{error}</span>
                        }
                    </div>
                    {
                        newChapter.img &&
                        <img src={arc.path.media + newChapter.img} className="card_image" alt=''/>
                    }
                </div>
                <div className="card_title">
                    <div className="index">
                        #
                        <Input theme='white' 
                            name='index'
                            value={newChapter.index}
                            handleParentChange={(name,value) => handleParentChange(name, value, true)}/> 
                        -
                    </div>
                    <Input theme='white' 
                            className='title-input'
                            name='title'
                            value={newChapter.title}
                            handleParentChange={(name,value) => handleParentChange(name, value, true)}/> 
                </div>     
            </div>
            }
            <div className="SubChapterCard new-card">
                <Icon svg={svgPlus} onClick={()=>addNewChapter()}/>
            </div>         
        </React.Fragment>
    );
}